import React from "react";
import Button from "../../components/ButtonUI";
import "../../pages/MyPatients/styles.scss";

interface Props {
  isOpen: boolean;
  onClose: Function;
  onConfirm: Function;
}

export const ConfirmationModal: React.FC<Props> = ({
  children,
  isOpen,
  onClose,
  onConfirm,
}) => {
  return isOpen ? (
    <div className="fixed inset-0 z-50 outline-none focus:outline-none overflow-x-hidden overflow-y-auto bg-opacity-modal flexCenter">
      <div className="absolute z-40 top-1/3 flexColCenter confirmAddPatient">
        <h2>{children || ""}</h2>
        <div className="flexCenter mt-6 buttons">
          <Button
            status="secondary"
            width={"119px"}
            height={"50px"}
            onClick={() => {
              onClose();
            }}
          >
            Annuler
          </Button>
          <Button
            status="secondary"
            width={"119px"}
            height={"50px"}
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            Confirmer
          </Button>
        </div>
      </div>
    </div>
  ) : null;
};
export default ConfirmationModal;
